import { render, staticRenderFns } from "./postCard.vue?vue&type=template&id=9df3da7c&scoped=true&"
import script from "./postCard.vue?vue&type=script&lang=js&"
export * from "./postCard.vue?vue&type=script&lang=js&"
import style0 from "./postCard.vue?vue&type=style&index=0&id=9df3da7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9df3da7c",
  null
  
)

export default component.exports